import { Card, CardContent, CardHeader } from '@mui/material'
import DashCard from '../../components/DashCard'
import API from '../../services/api'
import { useNotify } from 'react-admin'
import { useCallback, useEffect, useState } from 'react'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import GroupsIcon from '@mui/icons-material/Groups'
import SmartToy from '@mui/icons-material/SmartToy'
import Info from '@mui/icons-material/Info'
import QuestionMarkIcon from '@mui/icons-material/QuestionMark'
import {
  CardInfo,
  CardContentWrapper,
  CardInfoWrapper,
  InfoWrapper,
  CardInfoTitle,
  CardInfoDescription,
  CardInfoBtn,
} from './styles'

const Dashboard = () => {
  const notify = useNotify()

  const [data, setData] = useState<any>({
    clients: {
      total: 0,
      totalRegistered: 0,
      totalNotRegistered: 0,
    },
    groups: {
      total: 0,
      totalMonitoring: 0,
      totalNotMonitoring: 0,
    },
    bots: {
      total: 0,
      totalStarted: 0,
      totalStopped: 0,
    },
  })

  const loadDashboardStatistics = useCallback(async () => {
    try {
      const response = await API.get('/dashboard/statistics')

      setData(response.data)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }, [notify])

  useEffect(() => {
    loadDashboardStatistics()
  }, [loadDashboardStatistics])

  return (
    <Card>
      <CardHeader title="Bem-vindo(a) de volta 👋" />
      <CardContent>
        <CardContentWrapper>
          <DashCard
            title="Clientes"
            cardData={[
              { name: 'Total', value: data.clients.total, color: '#15C4DE' },
              { name: 'Cadastrados', value: data.clients.totalRegistered, color: '#13B478' },
              { name: 'Não Cadastrados', value: data.clients.totalNotRegistered, color: '#FEC144' },
            ]}
            icon={<PeopleAltIcon sx={{ width: '100px', height: '100px', color: '#13B478' }} />}
          />

          <DashCard
            title="Grupos"
            cardData={[
              { name: 'Total', value: data.groups.total, color: '#15C4DE' },
              { name: 'Monitorando', value: data.groups.totalMonitoring, color: '#13B478' },
              { name: 'Não Monitorando', value: data.groups.totalNotMonitoring, color: '#FEC144' },
            ]}
            icon={<GroupsIcon sx={{ width: '100px', height: '100px', color: '#15C4DE' }} />}
          />

          <DashCard
            title="Bots"
            cardData={[
              { name: 'Total', value: data.bots.total, color: '#15C4DE' },
              { name: 'Ligados', value: data.bots.totalStarted, color: '#13B478' },
              { name: 'Desligados', value: data.bots.totalStopped, color: '#FEC144' },
            ]}
            icon={<SmartToy sx={{ width: '100px', height: '100px', color: '#FEC144' }} />}
          />
        </CardContentWrapper>

        <CardInfoWrapper>
          <CardInfo>
            <InfoWrapper>
              <CardInfoTitle>Documentação</CardInfoTitle>

              <CardInfoDescription>
                Aprenda a utilizar o sistema com a nossa wiki, nela contem todos os detalhes de como
                configurar o seu bot!
              </CardInfoDescription>

              <CardInfoBtn
                onClick={() => {
                  window.open('http://wiki.connectm.com.br', '_blank')
                }}
              >
                Acessar
              </CardInfoBtn>
            </InfoWrapper>

            <div>
              <Info sx={{ width: '100px', height: '100px', color: '#00A76F' }} />
            </div>
          </CardInfo>

          <CardInfo>
            <InfoWrapper>
              <CardInfoTitle>Suporte</CardInfoTitle>

              <CardInfoDescription>
                Caso necessite de suporte clique no botão abaixo para que a nossa equipe possa te
                ajudar.
              </CardInfoDescription>

              <CardInfoBtn
                onClick={() => {
                  window.open('https://api.whatsapp.com/send?phone=5567981079863', '_blank')
                }}
              >
                Acessar
              </CardInfoBtn>
            </InfoWrapper>

            <div>
              <QuestionMarkIcon sx={{ width: '100px', height: '100px', color: '#00A76F' }} />
            </div>
          </CardInfo>
        </CardInfoWrapper>
      </CardContent>
    </Card>
  )
}

export default Dashboard
